// =========================================================
// * Vuetify Material Dashboard - v2.1.0
// =========================================================
//
// * Product Page: https://www.creative-tim.com/product/vuetify-material-dashboard
// * Copyright 2019 Creative Tim (https://www.creative-tim.com)
//
// * Coded by Creative Tim
//
// =========================================================
//
// * The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import './plugins/base'
import './plugins/vee-validate'
import vuetify from './plugins/vuetify'
import i18n from './i18n'
// import moment from 'moment'
import moment from 'moment-timezone'
import get from 'lodash/get'

import './registerServiceWorker'

// Vue.apiurl = 'https://swissflex.it/order23/api/'
Vue.prototype.$baseurl = 'http://localhost:8080/'
Vue.prototype.$rootpath = window.location.href.split('#')[0]

Vue.prototype.$siteTitle = 'EYE-Orders'
Vue.prototype.$online = navigator.onLine

Vue.prototype.$coalesce = (obj, path, needle) => get(obj, path, needle)

Vue.prototype.$formatDate = (date) => {
  if (date) {
    // return moment(date).format('DD/MM/YYYY HH:mm:ss')
    var cvdate = moment.utc(date).local()
    return cvdate.format('DD/MM/YYYY HH:mm:ss')
  }
  return ''
}

Vue.prototype.$linea = () => {
  return store.state.clidata.anlin.filter(item => item.codlin === store.state.order?.codlin)[0]
}

Vue.config.productionTip = false

export const globalevent = new Vue()

new Vue({
  router,
  store,
  vuetify,
  i18n,
  render: h => h(App),
}).$mount('#app')
